/**
 * This is a wrapper around router.push
 * It updates the URL but keeps the lang param as it is
 */
import { useCallback } from 'react'

import { useRouter, useParams } from 'next/navigation'

const useAppRouter = () => {
    const params = useParams()
    const router = useRouter()
    const appRouter = useCallback(
        (href: string) => {
            if (href.startsWith('/') === false)
                throw new Error(
                    'href must start with /. if your url does not start with slash, consider using useRouter hook instead.'
                )
            router.push(`/${params.lang}${href}`)
        },
        [router, params.lang]
    )
    return { appRouter }
}

export default useAppRouter
